module.exports = __webpack_public_path__ + "static/media/undraw_profile_6l1l.8858d90c.svg";